// parameter slice
import { createSlice } from "@reduxjs/toolkit";
import { firestore } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";

const initialState = {
  units: [],
  isLoading: false,
  error: false,
};

export const unitSlice = createSlice({
  name: "unit",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET units
    getUnitsSuccess(state, action) {
      state.isLoading = false;
      state.units = action.payload;
    },
    // create units
    createUnitsSuccess(state, action) {
      state.units.push(action.payload);
    },
    // update units
    updateUnitSuccess(state, action) {
      state.units = state.units.map((unit) => {
        if (unit.id === action.payload.id) {
          return action.payload;
        }
        return parameter;
      });
    },
    // delete souche
    deleteUnitSuccess(state, action) {
      const { id } = action.payload;
      state.units = state.units.filter((unit) => unit.id !== id);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  startLoading,
  hasError,
  getUnitsSuccess,
  createUnitsSuccess,
  updateUnitSuccess,
  deleteUnitSuccess,
} = unitSlice.actions;

// create units function

export const createUnit = (data) => async (dispatch) => {
  const docRef = collection(firestore, "units");
  const newData = {
    ...data,
    timestamp: serverTimestamp(),
  };
  try {
    dispatch(startLoading());
    const addedDocRef = await addDoc(docRef, newData);
    const id = addedDocRef.id;
    // Update the document with the ID
    const docToUpdate = doc(firestore, "units", id);
    await updateDoc(docToUpdate, { id });
    dispatch(createUnitsSuccess({ ...newData, id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// update parameter
export const updateUnit = (data) => async (dispatch) => {
  const { id, name, abbreviation } = data;
  const docRef = doc(firestore, "units", data.id);
  try {
    dispatch(startLoading());
    await updateDoc(docRef, { name, abbreviation });
    dispatch(updateUnitSuccess({ id, name, abbreviation }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// delete parameter
export const deleteUnit = (id) => async (dispatch) => {
  const docRef = doc(firestore, "units", id);
  try {
    dispatch(startLoading());
    await deleteDoc(docRef);
    dispatch(deleteUnitSuccess({ id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};

// get units from firestore
export const getUnits = () => async (dispatch) => {
  try {
    dispatch(startLoading());
    const querySnapshot = await getDocs(collection(firestore, "units"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch(getUnitsSuccess(data));
  } catch (error) {
    dispatch(hasError(error));
  }
};

export default unitSlice.reducer;
